import type { CartItem } from './CartItem'

export class Cart
{
  userId: number = 0
  items: CartItem[] = []

  replaceItems(newItems: CartItem[])
  {
    this.items.length = 0
    this.items.push(...newItems)
  }

  haveDiscounts(): boolean
  {
    return this.items.some(item => (item.custDiscountPct && item.custDiscountPct > 0)
      || (item.custDiscountPriceNet && item.custDiscountPriceNet > 0))
  }
}
